module.exports = __webpack_public_path__ + "components/easter-infographic/static/resort-opening-infographic--france--full-d1db672ea537d517e1fbb048a30a29fc.jpg";